import { getYear } from "date-fns";

export const isYearWithinBounds = (
	year: number,
	minDate?: Date,
	maxDate?: Date,
): boolean => {
	const afterMinimum = minDate === undefined || year >= getYear(minDate);
	const beforeMaximum = maxDate === undefined || year <= getYear(maxDate);

	return afterMinimum && beforeMaximum;
};
